export default __webpack_public_path__ + "static/media/616.0aeef7e2.gif";